export default __webpack_public_path__ + "static/media/episodeswitcher.1448f31d.png";